import { Icon, XOutlineIcon } from '@fountain/ripple/icon';
import { IconButton, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { iconLabels } from 'shared/iconLabels';

import messages from './messages';

const TemplateMenuHeader = ({ onClose }) => {
  const intl = useIntl();
  return (
    <>
      <Typography variant="h4">
        <FormattedMessage {...messages.dialogTitle} />
      </Typography>
      <IconButton
        aria-label={intl.formatMessage(iconLabels.close)}
        onClick={onClose}
        size="small"
      >
        <Icon icon={XOutlineIcon} size="lg" color="inherit" />
      </IconButton>
    </>
  );
};

TemplateMenuHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default TemplateMenuHeader;
